import { IntroIFrame, IntroWrapper } from '../__intro-elements';
import { IntroKeys } from '../intro-keys';
import styles from '../_intro.module.scss';

const ClipIntro = () => (
  <IntroWrapper>
    <p>
      <b>Clips</b> are the building blocks of your story. Each clip represents a highlight from your source footage.
    </p>
  </IntroWrapper>
);

const ClipControls = () => (
  <IntroWrapper size="medium">
    <p>Each clip has several controls:</p>
    <ul>
      <li>
        Click and drag to <b>reposition</b> the clip
      </li>
      <li>
        Click the <b>Settings Gear</b> to access effects and adjustments
      </li>
      <li>Drag the edge of the clip to lengthen or shorten its duration</li>
    </ul>
    <p>Try moving clips around to find the perfect sequence for your story!</p>
    <IntroIFrame src="https://youtube.com/embed/Wl3PwIB-DuU" />
  </IntroWrapper>
);

const ClipDuration = () => (
  <IntroWrapper size="medium">
    <p>
      <b>Clip Duration:</b> Each clip's duration is automatically determined by the music beats in the Music Track
      above. The clip will span from one beat marker to the next, ensuring your video is perfectly synchronized with the
      music.
    </p>
    <p>
      <b>Tip:</b> For the best results, we recommend keeping the default clip durations to ensure your montage stays
      perfectly synchronized with the music.
    </p>
    <p>If you do need to make adjustments, you can do so by dragging the edge of the clip.</p>
    <IntroIFrame src="https://youtube.com/embed/oklFo-ddFn4" />
    <p>
      <b>Note:</b> You can only resize to beat markers, not between them.
    </p>
    <p>
      <b>Reminder:</b> Use the <b>"Undo"</b> button if you need to revert your changes.
    </p>
  </IntroWrapper>
);

const ClipEffects = () => (
  <IntroWrapper size="medium">
    <p>
      <b>Clip Effects:</b> Click the settings gear on any clip to access effects like:
    </p>
    <ul>
      <li>Brightness and contrast</li>
      <li>Pan and zoom</li>
      <li>Playback speed</li>
      <li>Volume</li>
    </ul>
  </IntroWrapper>
);

export const TUTS_CLIP = [
  { element: `[data-intro="${IntroKeys.sbClip}"]`, intro: <ClipIntro /> },
  {
    element: `[data-intro="${IntroKeys.sbClip}"]`,
    intro: <ClipControls />,
    tooltipClass: styles.LengthenCell,
    position: 'right',
  },
  {
    element: `[data-intro="${IntroKeys.sbClip}"]`,
    intro: <ClipDuration />,
    tooltipClass: styles.LengthenCell,
    position: 'right',
  },
  { element: `[data-intro="${IntroKeys.sbClip}"]`, intro: <ClipEffects /> },
];
